import { Controller } from "@hotwired/stimulus"
import Lottie from "lottie-web/build/player/lottie_svg"
// import { DotLottie } from '@lottiefiles/dotlottie-web';

export default class extends Controller {
  static targets = ["canvas", "menu"]
  static values = { animationUrl: String }

  initialize() {
    this.animation = null
    this.allPlanets = [
      "ivd",
      "controls",
      "cell",
      "antigen",
      "services"
    ]

    this.colors = {
      ivd: "bg-trina-green-300/30",
      controls: "bg-trina-yellow-300/30",
      cell: "bg-trina-yellow-200/30",
      antigen: "bg-trina-blue-300/30",
      services: "bg-trina-blue-200/30"
    }
  }

  connect() {
    this.loadLottieAnimation()
  }

  disconnect() {
    if (this.animation) {
      this.animation.destroy()
    }
  }

  loadLottieAnimation() {
    this.animation = Lottie.loadAnimation({
      container: this.canvasTarget,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: this.animationUrlValue,
    })
  }

  mouseenter(event) {
    const planet = event.currentTarget.dataset.planet

    let element = event.currentTarget

    // if (planet == "cell") {
    //   let container = element.querySelector(".image-container")
    //   container.replaceChildren(document.createElement("canvas"))
    //   const dotLottie = new DotLottie({
    //     canvas: container.querySelector("canvas"),
    //     autoplay: true,
    //     loop: false,
    //     // eslint-disable-next-line no-undef
    //     src: RAILS_ASSET_URL("Planet_detailed_controls_v002_dle.lottie")
    //   });
    // }

    element.classList.remove("inactive")

    let inactiveElements = this.menuTarget.querySelectorAll("a")

    inactiveElements.forEach(el => {
      if (el !== element) {
        el.classList.add("inactive")
      }
    })

    let remainingPlanets = this.allPlanets.filter(p => p !== planet)

    remainingPlanets.forEach(p => {
      const elements = document.querySelectorAll(`.${p}`)
      elements.forEach(element => {
        element.classList.add("inactive")
      })
    })

    let planetElements = document.querySelectorAll(`.${planet}`)
    planetElements.forEach(element => {
      element.classList.remove("inactive")
    })
  }

  mouseleave() {
    this.allPlanets.forEach(p => {
      const elements = document.querySelectorAll(`.${p}`)
      elements.forEach(element => {
        element.classList.remove("inactive")
      })
      this.menuTarget.querySelectorAll("a").forEach(el => {
        el.classList.remove("inactive")
      })
    })
  }
}
